<template>
  <main class="fit" id="_member_page">
    <MemberHeader id="_tlqn_member_pager_header" />

    <router-view
      style="padding-top: 50px; max-width: 800px; margin: auto"
    ></router-view>
    <LockMask
      v-if="littleGroupState == '归来' || locked"
      :lockTip="locked? locked : '小组归队，如需修改信息请联系组长'"
    />
  </main>
</template>

<script>
import { getUserProfile } from "../../api/endpoints/auth/getUserProfile";
import { getUserSampleDetail } from "../../api/endpoints/user/getUserSampleDetail";
import { getAllSampleLabel } from "../../api/endpoints/sample-label/getAllSampleLabel";
import { getAllSampleStatus } from "../../api/endpoints/sample/getAllSampleStatus";
import { getUserLittleGroupState } from "../../api/endpoints/user/getUserLittleGroupState";
import UserDetailMixin from "./user-detail.mixin";
import SampleLabelMixin from "./sample-label.mixin";
import { SAMPLE_INFO_CHANGED } from "@/bus/member.events";
import { EventBus } from "../../bus";

export default {
  mixins: [UserDetailMixin, SampleLabelMixin],
  components: {
    MemberHeader: () => import("./Header"),
    LockMask: () => import("../../components/Mask.vue"),
  },
  data() {
    return {
      allSampleLabel: [],
      littleGroupState: "",
      locked: false,
    };
  },
  mounted() {
    this.initInfo();
    EventBus.$on(SAMPLE_INFO_CHANGED, this.initInfo);
  },

  watch: {
    // littleGroupState: {
    //   immediate: true,
    //   handler() {
    //     if (this.littleGroupState == "归来") {
    //       console.log("回来了！");
    //     }
    //   },
    // },
  },

  methods: {
    async initInfo() {
      try {
        const response = await getUserProfile();
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          await this.getUserLittleGroupState(response.id);
          await this.getUserSampleDetail(response.id);
          await this.getAllSampleLabel();
          await this.getAllSampleStatus();
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({ type: "danger", message: "获取用户信息失败" });
      }
    },

    async getUserSampleDetail(userId) {
      try {
        const response = await getUserSampleDetail(userId);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          // this.userDetail = response;
          this.$set(this, "userDetail", response);
          // console.log("userDetail", response);
        }
      } catch (err) {
        this.$q.notify({ type: "danger", message: "获取样本列表失败" });
      }
    },

    async getAllSampleLabel() {
      try {
        const response = await getAllSampleLabel();

        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          // this.$set(this, "sampleLabel", response);
          this.allSampleLabel = response;
          // console.log("sallSampleLabel",this.allSampleLabel)
        }
      } catch (err) {
        this.$q.notify({ type: "danger", message: "获取样本列表失败" });
      }
    },


    async getAllSampleStatus() {
      try {
        const response = await getAllSampleStatus();
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          // console.log('respone', response)
          const concatLabel = this.allSampleLabel.concat(response);
          // console.log(concatLabel);
          this.$set(this, "sampleLabel", concatLabel);
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({ type: "danger", message: "获取样本状态列表失败" });
      }
    },

    async getUserLittleGroupState(userId) {
      try {
        const response = await getUserLittleGroupState(userId);
        // console.log("res", response);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: '出现错误，可能是缺少调查小队信息。错误信息：' + response.detail || response.message,
          });
          this.locked = '缺少调查小队信息：请联系组长，分配调查小队'
        } else {
          this.littleGroupState = response;
        }
      } catch (error) {
        this.$q.notify({ type: "danger", message: "获取小组状态失败" });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

#_tlqn_member_pager_header {
  height: 50px;
  width: 100%;
  background-color: $tailong-dark-blue;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
}
</style>
